// TODO: convert this to hook

import _ from 'lodash';

export default function(eventId, programItem, callbacks) {
    callbacks = Object.assign({}, callbacks, {
        onStart: _.identity,
        onSuccess: _.identity,
        onError: _.identity,
        onEnd: _.identity,
    });
    callbacks.onStart();
    app.store.dispatch(app.actions.ui.busy());
    app.api.events
        .programItemSelection(eventId, programItem.id, false)
        .then(() => {
            callbacks.onSuccess();
        })
        .catch(error => {
            callbacks.onError();
        })
        .then(() => {
            app.store.dispatch(app.actions.ui.free());
            callbacks.onEnd();
        });
}
